var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBkash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 471.8 219",
    style: {
      enableBackground: "new 0 0 471.8 219"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010101;}\n\t.st1{fill:#F16522;}\n\t.st2{fill:#E41B24;}\n\t.st3{fill:#F89E1B;}\n\t.st4{fill:#00589F;}\n\t.st5{fill:#F9A51A;}\n\t.st6{fill:#EC1C24;}\n\t.st7{fill:#F6921E;}\n\t.st8{fill:#D12053;}\n\t.st9{fill:#E2136E;}\n\t.st10{fill:#9E1638;}\n\t.st11{fill:#FFFFFF;}\n\t.st12{fill:#006CB6;}\n\t.st13{fill:url(#SVGID_1_);}\n\t.st14{fill:#FBAE17;}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:#8B3392;}\n\t.st16{fill:#8B3392;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "323.7,104.7 336.9,163.7 422.7,120.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "348.1,16.6 323.8,104.7 422.7,120.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "243.3,3.7 345.6,15.9 321.4,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "242.5,20.9 253.9,20.9 285.9,61.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "425.5,119.7 395.7,78.5 443.8,69.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "420.5,131.8 423.5,122.6 348.4,160.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "321.7,107.1 337.3,177.5 290.8,215.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "439.1,90.8 466.4,90.4 446.7,70.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M5.3,78.5c1.3,0.1,2.7,0.4,4.1,0.4s2.6-0.2,4.1-0.4v43.8c4.3-7.3,9.7-12.2,17.7-12.2 c14.4,0,20.6,14.3,20.6,27.4c0,15.7-8.4,30.8-23.1,30.8c-6,0.1-11.6-3.1-14.5-8.3c-2.5,2.2-4.6,4.8-7,7.1H5.4L5.3,78.5z  M13.3,142.9c0,12.8,5.4,21.7,14.3,21.7c11.6,0,15.3-15.5,15.3-26.5c0-12.8-4.2-22.8-14.2-23C17,115,13.3,128.8,13.3,142.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5,106.8L80.8,118c8.2,11.9,16.6,23.6,24.9,35.7l8.3,13.1v0.7c-2-0.1-3.9-0.4-5.6-0.4s-3.9,0.3-5.7,0.4 c-2.3-4.2-4.5-8-7.1-11.8l-22.4-33.1c-0.5-0.5-1.7-0.9-1.7-0.4v45.4c-1.6-0.1-3.1-0.4-4.5-0.4s-3.1,0.3-4.5,0.4v-89 c1.4,0.1,3,0.4,4.5,0.4c1.5,0,2.9-0.3,4.5-0.4v40.2c0,0.8,1.5,0.3,2.5-0.8c1.9-2,3.8-4.1,5.4-6.4l25.2-33c1.3,0.1,2.7,0.4,4.1,0.4 c1.4,0,2.5-0.3,4-0.4L89.5,106.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.3,157.5c0,4.6-0.3,7,5.7,5.4v2.6c-1,0.5-2,0.9-3.1,1.2c-5.3,1.1-9.7,0.1-10.5-6.8l-0.9,1c-3.6,4.7-9.2,7.5-15.2,7.5 c-7.2,0-13.6-5.7-13.6-14.5c0-13.5,9.3-15.3,18.9-17c8.1-1.5,10.9-2.2,10.9-7.9c0-8.8-4.3-13.8-12-13.8c-5.4-0.1-10.2,3.2-12.2,8.2 h-1.1v-6.6c4.6-4,10.5-6.3,16.6-6.5c10.7,0,16.6,6.5,16.6,19.9L157.3,157.5z M149.1,137.9l-3.6,0.8c-7,1.5-17.4,2.7-17.4,13.5 c0,7.5,3.7,11.2,10,11.2c3.2-0.4,6.2-2,8.3-4.6c0.7-0.9,2.8-2.9,2.8-3.7L149.1,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5,155.9c2.4,4.6,6.9,8.8,11.8,8.8c5.7-0.3,10.2-5.1,10-10.8c0-16-24.2-5.6-24.2-26.3c0-11.3,7.5-17.5,16.7-17.5 c4.1-0.1,8.1,1,11.6,3.1c-1,2.7-1.8,5.5-2.4,8.4H198c-1.3-3.9-4.9-7.8-8.7-7.8c-5.1,0-9.3,3.5-9.3,9.9c0,15.1,24.2,7.1,24.2,26 c0,12.7-9.8,18.7-18.8,18.7c-4.5,0-9-1.3-12.8-3.7c0.9-2.8,1.6-5.7,2.1-8.7L175.5,155.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.9,78.5c1.4,0.1,2.7,0.4,4.1,0.4s2.6-0.2,4.1-0.4v43.1c3.6-7.2,9.2-11.5,16.5-11.5c11.9,0,16.5,8.1,16.5,23.1v34.3 c-1.5-0.1-2.7-0.4-4.1-0.4c-1.4,0-2.8,0.2-4.1,0.4v-31.6c0-13.1-2.6-19.7-11.3-19.7c-9.2,0-13.4,6.6-13.4,18.9v32.3 c-1.5-0.1-2.7-0.4-4.1-0.4s-2.7,0.2-4.1,0.4V78.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkash);
export default __webpack_public_path__ + "static/media/bkash.53f37802f779810fc14938a8cbbd37cb.svg";
export { ForwardRef as ReactComponent };